import type { ApplicationLocale } from 'types';

import type { i18nKeys } from '../source/i18nKeys';

export type NestedKeyOf<ObjectType extends object | string> = {
  [Key in keyof ObjectType]: ObjectType[Key] extends object | string
    ? NestedKeyOf<ObjectType[Key]>
    : Key;
}[keyof ObjectType];

export type i18nKey = NestedKeyOf<typeof i18nKeys>;

type DynamicTranslationValues = { [key: string]: string | number };

export type TranslateFunction = (key: i18nKey, params?: DynamicTranslationValues) => string;

//? To be used when the translation key is coming from a dynamic source to avoid an implicit any error
export type LooseTranslateFunction = (key: string, params?: DynamicTranslationValues) => string;

export interface TranslationState {
  currentLang: ApplicationLocale;
  t: TranslateFunction;
  tl: LooseTranslateFunction;
}

export const PLURAL_CATEGORIES = ['zero', 'one', 'many'] as const;

export type PluralCategory = (typeof PLURAL_CATEGORIES)[number];

export type PluralForms = Partial<Record<PluralCategory, string>>;

export type LocaleTree = any;
